<template>
  <ContentSection>
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />
    <!-- EVENTS -->
    <TransitionGroup
      tag="ul"
      name="list"
      mode="out-in"
      class="
        space-y-5
        sm:space-y-7
      "
    >
      <li
        v-for="entry in entries"
        :key="entry.id"
      >
        <CardEvent :data="entry" />
      </li>
    </TransitionGroup>

    <!-- NO RESULTS -->
    <div v-if="entries.length === 0" class="text-center">
      <IconMagnifyingGlass
        class="
          mx-auto mb-3 size-6
          sm:mb-5 sm:size-10
        "
      />
      <p>
        {{ $t('no_entries_found') }}
      </p>
    </div>

    <!-- LOAD MORE -->
    <Transition name="fade">
      <AppButton
        v-if="data.selection.value === 'auto' && parseInt(data.total) >= entries.length"
        variant="primary"
        class="mt-6"
        @click="loadMore"
      >
        {{ $t('load_more') }}
      </AppButton>
    </Transition>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsOverviewEventsFragment } from '#gql'

const props = defineProps<{ data: Enforce<MainComponentsOverviewEventsFragment> }>()

const {
  locale, locales,
} = useI18n()

const entries = ref(props.data.entries)
const page = ref(1)
const total = ref(props.data.total)

const GqlInstance = useGql()

async function loadMore() {
  let data = null

  const limit = parseInt(props.data.limit || '8')
  page.value += 1

  // Find the locale in the list of available locales by code
  const localeObj = locales.value.find(site => site.code === locale.value) || locales.value[0]

  // Only a a-plus site is allowed to show news from all sites
  if (localeObj.isMain) {
    data = await GqlInstance('Events', {
      sort: 'date_start asc | date asc',
      limit: limit,
      page: page.value,
      filter: { site: { contains: `_${localeObj.languageTag}` } },
    })
  } else {
    data = await GqlInstance('Events', {
      sort: 'date_start asc | date asc',
      limit: limit,
      page: page.value,
      site: locale.value,
    })
  }

  total.value = data.entries.total

  if (data.entries.data.length === 0) {
    return
  }

  entries.value = entries.value.concat(data.entries.data)
}
</script>
